import React from 'react'
import "../../pages/List/lista.scss";
import Side from "../../components/sidebar/Side.jsx"
import Lista from "../../components/lista/Lista.jsx"
import NavBar from '../../components/navbar/NavBar.jsx'


const Eventos = () => {
  return (
    <>
    <div className='home2'>
  <Side/>
  <div className='homeContainer2'>
    <div className='list'>
      <h1 className='listTittle'>Descripción del Evento</h1>
   <Lista/>
    </div>
  </div>
   <NavBar/>
    </div>
    </>
  )
}

export default Eventos